export interface CustomFormData {
  /**
   * @remarks - '|' delimited string for each key/value of form 
   */
  data: string;
  /**
   * @remarks - indicator name
   */
  indicatorName: string;
}
